'use strict';
module.exports = {
	stdout: false,
	stderr: false
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/chalk/node_modules/supports-color/browser.js
// module id = 395
// module chunks = 0